import { prefixLanguage } from '@utils/urls'

export const API_BASE_URL = prefixLanguage('/api/v1/')
export const prefixAPI = url => API_BASE_URL + url
